import script from "./Business-big.vue?vue&type=script&setup=true&lang=js"
export * from "./Business-big.vue?vue&type=script&setup=true&lang=js"

import "./Business-big.vue?vue&type=style&index=0&id=615fe609&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-615fe609"]])

export default __exports__